/* eslint-disable react/no-danger */
// Components
import TableBonus from "components/atoms/TableBonus";

// Hooks
import useTranslate from "hooks/useTranslate";

import "./styles.sass";

const WelcomeDescription = () => {
  const t = useTranslate();

  const bonusFormatText = t("info.promo.welcome.winback.new.description");
  return (
    <div className="WelcomeDescription">
      <span className="WelcomeDescription__header">
        {t("info.promo.welcome.winback.title")}
      </span>
      <span dangerouslySetInnerHTML={{ __html: bonusFormatText }} />
      <span className="WelcomeDescription__desc">
        {t("info.promo.welcome.winback.new.extra.description")}
      </span>
      <span className="WelcomeDescription__title">
        {t("info.promo.welcome.table")}
      </span>
      <div className="WelcomeDescription__table">
        <TableBonus />
      </div>
    </div>
  );
};

export default WelcomeDescription;
